module.exports = __webpack_public_path__ + "static/Fallback05-549419007af8169f566ad2144031c008.jpg";